/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
import styles from './styles';
import axios from 'axios';
import {
  calcRR,
  ITMPROB,
  LinearProgressWithLabel,
} from '../OI Modal/functions';
import Typography from '@material-ui/core/Typography';

import _ from 'lodash';
import { dataFunc, plugins, chartOptionsFun } from './constant';
import { BaseURL } from '../../../constants';
class RRDOLLAR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderBy: '',
      order: '',
      data: [],
      modalLoader: false,
      graphState: [],
      PointedIndex: 0,
    };
  }

  checkStatus = (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const error = new Error(`HTTP Error: ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
  };
  parseJSON = (response) => {
    if (response) return response.json();
  };

  getRRModelData = async (
    ticker,
    strike,
    date,
    puttCall,
    expiration,
    indexDate,
    option
  ) => {
    this.setState({ modalLoader: true });
    let newDate = moment().format('YYYY-MM-DD');
    let check = moment(expiration).isBefore(newDate) && option > 0;
    fetch(
      `${BaseURL}/api/get-oi-data?ticker=${ticker}&date=${date}&strike=${strike}&puttCall=${puttCall}&expiration=${expiration}&range=${6}`
    )
      .then(this.checkStatus)
      .then(this.parseJSON)
      .then(async (response) => {
        if (!response || response.error) {
          this.setState({ modalLoader: false });
          return;
        }
        let beginDate = moment(response[0].date).format('YYYYMMDD');

        const lastDate = moment(response[response.length - 1].date).format('YYYY-MM-DD');
        const isSame = moment(lastDate).isSame(moment(newDate))
        let endDate = isSame
          ? moment(response[response.length - 2].date).format('YYYYMMDD')
          : moment(response[response.length - 1].date).format('YYYYMMDD');
        const data = await axios.get(
          `${BaseURL}/api/get-6m-history/${ticker}?begin_date=${beginDate}&end_date=${endDate}`
        );
        const todayData = await axios.get(
          `${BaseURL}/api/get-ticker-details/${ticker}`
        );
        const datatoMap = data.data;

        const todayDataArray = todayData.data[0];

        let todayArraytoConcat = {
          date: moment(todayDataArray.date).format('YYYY-MM-DD'),
          usymbol: todayDataArray.usymbol,
          close: +todayDataArray.spot,
        };

        const formattedTodayDate = moment(todayArraytoConcat.date).format('YYYY-MM-DD');

        const mergedItems = datatoMap
          .map(item => {
            const formattedItemDate = moment(item.date).format('YYYY-MM-DD');
            return formattedItemDate === formattedTodayDate ? { ...item, ...todayArraytoConcat } : item;
          })
          .concat(
            !datatoMap.some(item => moment(item.date).format('YYYY-MM-DD') === formattedTodayDate)
              ? [todayArraytoConcat]
              : []
          );

        let result = mergedItems.filter((o1) =>
          response.some((o2) => o1.date === o2.date)
        );

        let newResult = result.map((oneData) => {
          return { date: oneData.date, stockPrice: oneData.close };
        });
        let merge = _.merge(response, newResult);
        let StateMapper = await Promise.all(
          merge.map(async (res) => {
            let itemProb = res.itm_prob
              ? res.itm_prob
              : check
                ? 1.0
                : await ITMPROB(res, puttCall, expiration);
            let RR = await calcRR(res, puttCall, itemProb, strike);
            return {
              strike: strike,
              weeks: res.date,
              closed: res.stockPrice,
              RR: RR,
            };
          })
        );
        const index = StateMapper.findIndex((object) => {
          return object.weeks === indexDate;
        });

        const filterValidDates = StateMapper.filter((obj) => obj.closed)
        this.setState({ graphState: filterValidDates, PointedIndex: index });
        this.setState({ modalLoader: false });
      });
  };

  customRadius = (context) => {
    let index = context.dataIndex;
    let value = this.state.PointedIndex;
    return index === value ? 5 : 0;
  };
  componentDidMount() {
    const ticker = this.props.ticker;
    const indexDate = this.props.modalRowData.date;
    const strike = this.props.modalRowData.strike;
    const puttCall = this.props.modalRowData.put_call;
    const expiration = this.props.expiration;
    const date = moment(new Date()).format('YYYY-MM-DD');
    const option = this.props.modalRowData.option;
    this.getRRModelData(
      ticker,
      strike,
      date,
      puttCall,
      expiration,
      indexDate,
      option
    );
  }

  render() {
    const { isMobile, showModal, setrrModal, modalRowData } = this.props;
    const close = [];
    const strike = [];
    const weeks = [];
    const RR = [];
    for (const [key, value] of Object.entries(this.state.graphState)) {
      let newWeeks = moment(value.weeks).format('DD-MMM');
      weeks.push(newWeeks);
      close.push(value.closed);
      strike.push(value.strike);
      RR.push(value.RR);
    }

    const chartOptions = chartOptionsFun(
      modalRowData,
      this.customRadius,
      this.props.ticker
    );

    const labels = weeks;

    const data = dataFunc(labels, close, strike, RR);

    return (
      <div style={isMobile ? { width: '220px' } : { width: '400px' }}>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={showModal}
          onClose={() => setrrModal(false)}
        >
          <div
            style={
              isMobile
                ? styles.boardModalContentMobile
                : styles.boardModalContent
            }
          >
            <div
              onClick={() => setrrModal(false)}
              style={
                !isMobile
                  ? styles.modalCloseButton
                  : styles.modalCloseButtonMobile
              }
            >
              X
            </div>
            <div style={styles.boardModalData}>
              {this.state.modalLoader ? (
                <div style={{ paddingTop: '50px' }}>
                  <LinearProgressWithLabel />

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{ display: 'flex', justifyContent: 'center' }}
                  >
                    {' '}
                    Please standby. Retrieving the data...{' '}
                  </Typography>
                </div>
              ) : (
                <div
                  style={
                    isMobile
                      ? styles.boardModalBigGraphMobile
                      : styles.boardModalBigGraph
                  }
                >
                  <Bar
                    height={180}
                    options={chartOptions}
                    data={data}
                    plugins={plugins}
                  />
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default RRDOLLAR;



// WEBPACK FOOTER //
// ./src/components/Modals/RRDollarModal/index.js